export const environment = {
  version: '1.0',
  production: false,
  env: 'test',
  appName: 'Visitas Digitales',
  apiUrl: 'https://app-citronella-demo-test.azurewebsites.net/WebServices',
  geocodingApiKey: '',
  loginVersion: 1,
  commentTypeId: 1,
  locationCustomerId: 2,
};
